import './App.css';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { Route, Routes } from 'react-router-dom';
import 'leaflet/dist/leaflet.css'
import theme from './theme'
import AppBar from './components/AppBar';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Security } from '@okta/okta-react';
import CustomLoginCallback from './components/CustomLoginCallback';
import Loader from './components/Loader';
import ErrorToast from './components/ErrorToast';
import { oktaAuth } from './oktaConfig';
import IndexPage from './pages/home';
import { TabData } from './components/InterfaceInfo';
import CheckLogin from './components/CheckLogin';
import { About } from './pages/About';
import Dashboard from './pages/admin/Dashboard';
import { HelpComp } from './pages/Help';
import Index from './pages/online-maps';

// Parse the environment variable 
const tabData: TabData = JSON.parse(process.env.REACT_APP_TAB || '{}');

function App() {
  const restoreOriginalUri = async (_: any, originalUri: string | undefined) => {
    if (originalUri) {
      window.location.replace(originalUri);
    } else {
      window.location.replace('/');
    }
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <div className='h-screen max-h-screen w-screen bg-green-300 flex flex-col items-stretch align-items-start'>
            <AppBar />
            <Routes>
            <Route path="/" element={<IndexPage menuIndex={0} />} />
            <Route path="/login/callback" element={<CustomLoginCallback />} />
            {tabData.number_of_menus > 0 && tabData.details_of_menus.map((menu, menuIndex) => (
              <Route path={menu.path} element={<IndexPage key={menuIndex} menuIndex={menuIndex} />} />
            ))}
            <Route path="/admin" element={<CheckLogin><Dashboard/></CheckLogin>} />
            <Route path="/about" element={<CheckLogin><About/></CheckLogin>} />
            <Route path="/help" element={<CheckLogin><HelpComp/></CheckLogin>} />
            </Routes>
          </div>
        </ThemeProvider>
      </LocalizationProvider>
      <Loader />
      <ErrorToast />
    </Security>
  );
}

export default App;